{
  "header": {
    "title": "Umfragevorlagen",
    "description": "Durchsuchen und personalisieren Sie vorgefertigte Umfragevorlagen, um schnell aussagekräftige Einblicke in die Mitarbeitenden zu gewinnen"
  },
  "tabs": {
    "chirpeeTemplates": "Chirpee-Vorlagen",
    "companyTemplates": "Unternehmensvorlagen",
    "myTemplates": "Meine Vorlagen"
  },
  "searchInput": {
    "placeholder": "Vorlagen suchen"
  },
  "sortDropdown": {
    "triggerLabel": "Sortieren nach",
    "options": {
      "questionQuantity": "Fragenanzahl",
      "fromNewestToOldest": "Von neuestem zu ältestem",
      "fromOldestToNewest": "Von ältestem zu neuestem"
    }
  }
}
